
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21zm8.608-27.22a2.756 2.756 0 011.939 1.939c.471 1.721.453 5.31.453 5.31s0 3.57-.453 5.291a2.756 2.756 0 01-1.94 1.939c-1.72.453-8.607.453-8.607.453s-6.868 0-8.608-.471a2.757 2.757 0 01-1.939-1.94C10 25.599 10 22.012 10 22.012s0-3.57.453-5.292a2.813 2.813 0 011.939-1.957c1.722-.453 8.608-.453 8.608-.453s6.886 0 8.608.47z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.807 25.309l5.727-3.298-5.727-3.299v6.597z","fill":"#fff"}})])
          )
        }
      }
    